// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itinerary-modal-success-wrapper .header-text {
  font-size: 20px;
  font-weight: 400;
  color: #00A337;
}
.itinerary-modal-success-wrapper .subheader-text {
  font-size: 18px;
  font-weight: 400;
  color: #3a3a3a;
}
.itinerary-modal-success-wrapper .details-card {
  border: 1px solid #ddd;
  border-radius: 6px;
}
.itinerary-modal-success-wrapper .details-card span {
  color: #3a3a3a;
  letter-spacing: 0.03em;
}
.itinerary-modal-success-wrapper .details-card .transit-text {
  font-size: 20px;
  font-weight: 700;
  white-space: nowrap;
}
.itinerary-modal-success-wrapper .details-card .date-text {
  font-size: 18px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/ItinerarySuccessModal/style.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAAR;AAGI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AADR;AAII;EACI,sBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,cAAA;EACA,sBAAA;AAFZ;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,mBAAA;AAHZ;AAMQ;EACI,eAAA;EACA,gBAAA;AAJZ","sourcesContent":[".itinerary-modal-success-wrapper {\n    .header-text {\n        font-size: 20px;\n        font-weight: 400;\n        color: #00A337;\n    }\n\n    .subheader-text {\n        font-size: 18px;\n        font-weight: 400;\n        color: #3a3a3a;\n    }\n\n    .details-card {\n        border: 1px solid #ddd;\n        border-radius: 6px;\n\n        span {\n            color: #3a3a3a;\n            letter-spacing: 0.03em;\n        }\n\n        .transit-text {\n            font-size: 20px;\n            font-weight: 700;\n            white-space: nowrap;\n        }\n\n        .date-text {\n            font-size: 18px;\n            font-weight: 400;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
